// import { Component, OnInit } from '@angular/core';
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { LotteryResponseModel } from "src/app/model/LotteryResponseModel";
import { OrganizationResponseModel } from "src/app/model/OrganizationResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { AnnouncementResponseModel } from "src/app/model/AnnouncementResponseModel";
import { AnnouncementListModel } from "src/app/model/AnnouncementListModel";



@Component({
  selector: 'app-announcement-list',
  templateUrl: './announcement-list.component.html',
  styleUrls: ['./announcement-list.component.scss'],
})
export class AnnouncementListComponent implements OnInit {
  

  page: Page<AnnouncementResponseModel>;
  // dataSource: MatTableDataSource<OrganizationResponseModel> = new MatTableDataSource();
  dataSource: MatTableDataSource<BoardResponseModel> = new MatTableDataSource();
  dataSourceLottery: MatTableDataSource<AnnouncementResponseModel>; // Change 'any' to the type of your data if possible

  pageSizeOptions: number[] = [10, 25, 100, 150];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  dataSources: any ;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "lotteryCode",
    "announcementEn",
    "lotteryBoard",
    "lotteryStage",
    "createdOnDate",
    // "isActive",
    "action"
  ];

  constructor(public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
    ) {}

    ngOnInit(): void {
      this.filterForm = new FormGroup({
        filterText: new FormControl(null, [Validators.required, Validators.minLength(3)])
      });
  
      this.onLoad();
    }
  
    resetFilter() {
      this.filterForm.controls['filterText'].setValue(null);
      this.onLoad();
    }
  
    onLoad() {
      // this.isLoading = true;
      // console.log("in Onload");
      // this.masterService.fetchAnnouncementList(this.currentPage, this.pageSize, this.filterForm.value.filterText).subscribe((page) => {
      //   this.page = page;
      //   this.dataSourceLottery = new MatTableDataSource(page.content);
      //   console.log(page.content);
      //   setTimeout(() => {
      //     this.paginator.pageIndex = this.currentPage;
      //     this.paginator.length = page.totalElements;
      //     console.log(this.paginator.pageIndex);
      //     console.log(this.paginator.length);
      //   });
      //   this.isSearchDisabled = false;
      //   this.isLoading = false;
      // },
      // (error) => {
      //     console.log(error);
      //     this.isLoading = false;
      //     this.isSearchDisabled = false;
      // });

      this.isLoading = true;

      console.log("in Onload");
      this.masterService.fetchAnnouncementList(this.currentPage, this.pageSize,this.filterForm.value.filterText).subscribe((data: any) => {
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>OK",data);
        this.dataSourceLottery = new MatTableDataSource<any>(data.page.content);
          this.page = this.page;
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = data.page.totalElements;
          console.log("pageIndex",this.paginator.pageIndex);
          console.log(this.paginator.length);
        });
      
        this.isSearchDisabled = false;
        this.isLoading = false;
      },
      (error) => {
        // Handle errors if any
        console.error("Error fetching announcement list:", error);
        this.isLoading = false; // Ensure isLoading is set to false in case of error
      });
      
    }
  
    onSearch() {
      if (this.filterForm.valid) {
        console.log("onSearch");
        console.log(this.filterForm.valid);
        this.onLoad();
      }
      else {
        this._snackBar.open("Please enter Filter text (minimum - 3 char) for Lottery", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        });
        this.isSearchDisabled = false;
      }
    }
  
  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }


  editAnnouncement(announcementKey: number) {
    console.log("Edit Announcement called ******** key for Announcement edit"+announcementKey);
    this.router.navigate(['/secure','announcement', 'au', announcementKey]);
  }

  deactivate(key: number) {
    if(confirm("Do you want to De-Activate the Announcement")) {
      this.masterService.toggleActivationAnnouncement(key, 'N').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'N';
          this.successToast("Announcement De-Activate.");
        }
        else {
          this.errorToast(data.errorMessage);
        }
      });
    } 
  }
 
  activate(key: number) {
    if(confirm("Do you want to Activate the Announcement")) {
      this.masterService.toggleActivationAnnouncement(key, 'Y').subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          let selectedObj = this.page.content.find(o => o.key === key);
          selectedObj.activeFlag = 'Y';
          this.successToast("Announcement Activeted.");
        }
        else {
          this.errorToast(data.errorMessage);
        }
      });
    } 
  }

  async successToast(msg: string) {
    await this._snackBar.open(
      msg,
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }

}
